import TableSearch from 'components/Table/TableSearch';
import { useMemo, useState } from 'react';
import LoadingButton from '@enerex/unified-ui-react/LoadingButton';
import Table from '@enerex/unified-ui-react/Table';

import { createAssociationColumns } from './associationColumns';

const RateClassAssociationSection = ({ title, addLabel, rows, nameHeader, aliasHeader, supplierHeader, emptyText, loading, showAliasColumn, showSupplierColumn, scrollable, maxHeight = 230, disabled, disabledText, onAdd, onDelete }) => {
  const [search, setSearch] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const columns = useMemo(() => createAssociationColumns({ nameHeader, aliasHeader, supplierHeader, showAliasColumn, showSupplierColumn, onDelete }), [nameHeader, aliasHeader, supplierHeader, showAliasColumn, showSupplierColumn, onDelete]);
  const filteredRows = useMemo(() => {
    const normalizedSearch = search.trim().toLowerCase();

    if (!normalizedSearch) return rows;

    return rows.filter((row) => [
      row.rateClassName,
      row.utilityName,
      row.supplierName,
      row.commodity,
    ].some((value) => String(value || '').toLowerCase().includes(normalizedSearch)));
  }, [rows, search]);
  const handleSearch = (value) => {
    setSearch(value);
  };

  return (
    <div className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="mb-0">{title}</h5>
        <LoadingButton size="sm" variant="primary" disabled={disabled} onClick={onAdd}>
          <i className="uil uil-plus me-1" />{addLabel}
        </LoadingButton>
      </div>

      <div className="d-flex justify-content-start mb-2">
        <div style={{ width: 260 }}>
          <TableSearch appliedSearch={search} value={searchInput} onChange={setSearchInput} onSearch={handleSearch}
            placeholder="Search..." />
        </div>
      </div>

      <Table
        id={`rate-class-association-${title.toLowerCase().replace(/\s+/g, '-')}`}
        data={filteredRows}
        columns={columns}
        loading={loading}
        total={filteredRows.length}
        maxHeight={scrollable ? maxHeight : undefined}
        enableSearch={false}
        enablePagination={false}
        enableSorting={true}
        enableFilters={false}
        enableExport={false}
        enableHideColumns={false}
        noDataMessage={emptyText}
      />
    </div>
  );
};

export default RateClassAssociationSection;
